import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["organizationFields", "individualFields"]

  connect() {
    this.sync()
  }

  switchType(event) {
    event.preventDefault()
    const type = event.currentTarget.dataset.companyType
    const input = this.element.querySelector('input[name="company[company_type]"]')
    if (!input) return

    input.value = type
    this.render(type)
  }

  sync() {
    const type = this.element.querySelector('input[name="company[company_type]"]')?.value
    if (type === 'organization' || type === 'individual') this.render(type)
  }

  render(type) {
    this.element.querySelectorAll('[data-company-type]').forEach(button => {
      const selected = button.dataset.companyType === type
      button.setAttribute('aria-pressed', selected)

      if (selected) {
        button.classList.remove('text-zinc-600', 'hover:text-zinc-800')
        button.classList.add('bg-white', 'text-black', 'shadow', 'font-medium')
      } else {
        button.classList.remove('bg-white', 'text-black', 'shadow', 'font-medium')
        button.classList.add('text-zinc-600', 'hover:text-zinc-800')
      }
    })
    
    if (type === 'organization' && this.hasOrganizationFieldsTarget && this.hasIndividualFieldsTarget) {
      this.organizationFieldsTarget.classList.remove('hidden')
      this.individualFieldsTarget.classList.add('hidden')
    } else if (this.hasOrganizationFieldsTarget && this.hasIndividualFieldsTarget) {
      this.organizationFieldsTarget.classList.add('hidden')
      this.individualFieldsTarget.classList.remove('hidden')
    }
  }
}
